module.exports = __webpack_public_path__ + "img/home-setting-ware-1.13470c02.png";